export default "__VITE_ASSET__Ds$QwvIP__"